import axiosInstance from "services/AxiosInstance";
import { ResponseType, TUser } from "types";

type GetUserInfoServiceArgs = (userId: string) => Promise<ResponseType<TUser>>;

export const getUserInfoService: GetUserInfoServiceArgs = async (userId: string) => {
  const response = await axiosInstance.get(`/users/${userId}`);
  return response.data;
};
